export type { AutosBadgesProps } from './AutosBadges'
export { AutosBadges } from './AutosBadges'
